import React, { useState } from 'react';
import SegmentedToggle from '../../../Elements/SegmentedToggle';

const CURRENCIES = [
  { value: 'Native', label: 'Native' },
  { value: 'USD', label: 'USD' },
];

const PERIODS = [
  { value: 'Day', label: 'Day' },
  { value: 'Week', label: 'Week' },
  { value: 'Month', label: 'Month' },
];

function SegmentedToggleDemoComponent() {
  const [currency, setCurrency] = useState('Native');
  const [period, setPeriod] = useState('Week');
  return (
    <div>
      <div className='dsg-row'>
        <div className='dsg-demo-label'>Two choices</div>
        <SegmentedToggle
          options={CURRENCIES}
          value={currency}
          onChange={setCurrency}
        />
      </div>
      <div className='dsg-row'>
        <div className='dsg-demo-label'>Three choices</div>
        <SegmentedToggle
          options={PERIODS}
          value={period}
          onChange={setPeriod}
        />
      </div>
    </div>
  );
}

export const segmentedToggleDemo = {
  id: 'segmented-toggle',
  title: 'Segmented toggle',
  category: 'Basics',
  importPath: 'Elements/SegmentedToggle',
  notes: [
    'One of two or three short, mutually exclusive choices, all in view: Native / USD on the Client Pricing History tab. Props: options [{ value, label }], value, onChange(value), className.',
    'It is the .ds-seg control (Css/Input.css, dark mode included) that the Bool input renders as Yes / No; see "Toggles & booleans". No button is on when value matches none of the options.',
    'For more choices, or long labels, use a Select.',
  ],
  snippet:
    "<SegmentedToggle\n  options={[{ value: 'Native', label: 'Native' }, { value: 'USD', label: 'USD' }]}\n  value={currency}\n  onChange={setCurrency}\n/>",
  render: SegmentedToggleDemoComponent,
};
